import { MAIN_PATH } from 'cpmMyOnDemandAccess/navigation';

module.exports = {
  path: MAIN_PATH,
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/MainApp'));
    });
  },
  getChildRoutes(partialNextState, cb) {
    require.ensure([], (require) => {
      cb(null, [
        require('./routes/show'),
        require('./routes/extend'),
        require('./routes/overstay'),
      ]);
    });
  },
};



// WEBPACK FOOTER //
// ./routes/my_on_demand_access/index.js